import { render, staticRenderFns } from "./relateCli.vue?vue&type=template&id=03d2ea95&"
import script from "./relateCli.vue?vue&type=script&lang=ts&"
export * from "./relateCli.vue?vue&type=script&lang=ts&"
import style0 from "./relateCli.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports